import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { PartnerForm } from "@/components/PartnerForm";
import { IMAGES } from "@/lib/site";
import { Recycle, Ship, Warehouse, Truck } from "lucide-react";

const cats = [
  { icon: Recycle, t: "Reprocessors & Paper Mills", d: "Access suitable UK recovered-fibre supply opportunities matched to your grade and specification requirements." },
  { icon: Ship, t: "Exporters & Material Traders", d: "Discuss eligible recovered-paper and cardboard streams for accredited export markets." },
  { icon: Warehouse, t: "Waste & Recycling Facilities", d: "Explore regional receiving and processing opportunities across our network." },
  { icon: Truck, t: "Hauliers", d: "Work with us on recurring industrial recycling movements between producer and receiving sites." },
];

export default function Partners() {
  return (
    <>
      <section className="relative pt-36 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden border-b border-dc-border">
        <div className="absolute inset-0 z-0">
          <img src={IMAGES.paperMill} alt="Paper mill" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-dc-bg/70" />
        </div>
        <div className="relative z-10 max-w-[1400px] mx-auto">
          <span className="dc-label">Partner Network</span>
          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="font-display uppercase tracking-tighter text-5xl sm:text-6xl lg:text-7xl font-semibold leading-[0.92] mt-6 max-w-4xl">
            A Brokerage Network Built for Volume
          </motion.h1>
          <p className="mt-6 max-w-2xl text-dc-text2 leading-relaxed">We develop relationships across the recovered-material supply chain to create reliable, commercially attractive routes for UK recovered paper and cardboard tonnage.</p>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-dc-border border border-dc-border">
          {cats.map((c, i) => (
            <Reveal key={c.t} delay={i * 0.08}>
              <div className="bg-dc-bg p-8 h-full group hover:bg-dc-surface transition-colors">
                <c.icon className="text-dc-accent mb-6" size={28} strokeWidth={1.5} />
                <h3 className="font-display text-xl mb-3">{c.t}</h3>
                <p className="text-dc-text2 text-sm leading-relaxed">{c.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section id="partner-form" className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <span className="dc-label">Partner Enquiry</span>
            <h2 className="font-display uppercase tracking-tight text-3xl lg:text-4xl font-semibold mt-4 mb-6 leading-[0.95]">Tell Us About Your Capabilities</h2>
            <p className="text-dc-text2 leading-relaxed">Complete the form and our commercial team will review your operating regions, materials and capacity to identify suitable opportunities across the network.</p>
          </div>
          <div className="lg:col-span-8"><PartnerForm /></div>
        </div>
      </section>
    </>
  );
}
